import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { actionCreators } from '../../store/Login';
import { bindActionCreators } from 'redux';
import { ReturnSalesOrderItems } from './ReturnSalesOrderItems';
import { toast } from 'react-toastify';
import { DateConst, BlankOrderGuideGroup } from '../shared/consts';

export class ReturnSalesOrder extends Component {
    displayName = ReturnSalesOrder.name;
    
    constructor(props) {
        super(props);

        this.state = {
            storeId: undefined,
            isAdmin: false,
            loading: false,
            currOrder: false,
            salesOrderItems: [],
            orderGuideDeliveryDate: new Date(),
            orderGuideGroup: BlankOrderGuideGroup
        };

        var d = new Date();
        if (this.props.isSameDay === false) {
            d = new Date(this.state.orderGuideDeliveryDate);
        }
        var monthName = DateConst.months[d.getMonth()];
        this.deliveryDate = monthName + " " + d.getDate().toString() + ", " + d.getFullYear().toString();
    }

    componentDidMount = async () => {
        this.setState({ loading: true });

        try {
            const fetchConfig = {
                method: 'GET', headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
            };
            const response = await fetch('api/OrderGuideGroups/settings', fetchConfig);
            if (response.ok) {
                let data = await response.json();

                this.setState({
                    orderGuideGroup: data.orderGuideGroup,
                    stores: data.assignedStores
                });

                if (this.state.stores && this.state.stores.length > 0) {
                    this.setState({ storeId: this.state.stores[0].storeId });

                    const fetchConfig = {
                        method: 'GET',
                        headers: {
                            'Authorization': `Bearer ${localStorage.getItem('token')}`
                        }
                    };

                    const response2 = await fetch('api/Reports/SOHistoryDetails?soHistoryId=' + this.props.soHistoryId, fetchConfig);
                    if (await response2.ok) {
                        let data2 = await response2.json();
                       
                        this.setState({ salesOrderItems: data2 }); 
                    }
                }
                else {
                    // This really shouldn't happen
                    console.log('No stores for Order Guide assigned to this user');
                    toast.error('No stores for Order Guide assigned to this user');
                }
            }
            else if (response.status === 401) {
                toast.error("Unauthorized.");
                this.props.signOut();
            }
            else {
                toast.error(`Error fetching Order Guide settings.`);
                console.log(`Error fetching Order Guide settings: ${await response.text()}.`);
            }
        }
        catch (e) {
            console.log("Error fetching Order Guide settings: " + e);
        }
        this.setState({ loading: false });
    }

    setCurrOrder = () => {
        this.setState({ currOrder: !this.state.currOrder });
    }

    updateRow = (idx) => async (evt) => {
        const so = this.state.salesOrderItems.filter((n) => n.productId === idx);
        so[0].qtyToOrder = evt.target.value;
        so[0].cO = true;
        await this.setState({ so });
    }

    render() {
        if (this.state.loading) {
            return <p style={{ padding: '10px' }}><em>Loading...</em></p>;
        }

        return (
            <div>
                {this.state.salesOrderItems.length !== 0 &&
                    <div>
                        <div id="divToPrint">
                        <ReturnSalesOrderItems
                            orderGuideGroup={this.state.orderGuideGroup}
                            salesOrderItems={this.state.salesOrderItems}
                            updateRow={this.updateRow}
                            currOrder={this.state.currOrder}
                            isCreditable={this.props.isCreditable}
                            requestCredit={this.props.requestCredit}
                        />
                        </div>
                    </div>
                }           
            </div>
        );
    }
}
export default withRouter(connect(state => state.login,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(ReturnSalesOrder));


// WEBPACK FOOTER //
// ./src/components/Report/SOReturn.js